// extracted by mini-css-extract-plugin
module.exports = {"border":"layout_border__CcOZG"};